// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"Success_contentWrapper__E5FwR","title":"Success_title__x3e0l","skeleton-loading":"Success_skeleton-loading__ScmWR"};